<template>
    <div role="navigation">
        <!-- Browser Support Notification -->
        <BrowserSupport />
        <!-- End Browser Support Notification -->
        <Cms
            v-show="false"
            model="navigation-link"
            is-data
            driver="builder"
            :search-params="searchParams"
            v-model="links"
        />

        <header style="position: relative;">
            <Link :href="route('home')" aria-label="Rothco home page" class="rothco-logo">
                <RothcoIcon
                    class="mobile-hidden"
                    alt="Rothco logo"
                />
                <RothcoMobileIcon
                    class="desktop-hidden"
                    alt="Rothco logo"
                />
            </Link>
            <div v-if="!isApiServer" class="header-content-container">
                <div class="header-utility-container">
                    <p class="italic">
                        Military, Tactical, Work & Outdoor Since 1953
                    </p>
                    <nav class="utility-links"
                         role="navigation"
                         aria-label="Header utility links"
                    >
                        <Link :href="route('index.becomeADealer')" v-if="!isDealer" aria-label="Become a Dealer" role="link">
                            <DealerIcon
                                alt="dealer icon"
                                aria-hidden="true"
                                class="utility-icon"
                            />
                            <span>Become a Dealer</span>
                        </Link>
                        <Link :href="route('retail.locator.search')" v-if="!isDealer" aria-label="Retail Locator" role="link">
                            <RetailIcon
                                alt="retail icon"
                                aria-hidden="true"
                                class="utility-icon"
                            />
                            <span>Retail Locator</span>
                        </Link>
                        <Link :href="route('dealertools.show')" v-if="isDealer" aria-label="Dealer Tools" role="link">
                            <DealerToolsIcon
                                alt="dealer icon"
                                aria-hidden="true"
                                class="utility-icon"
                            />
                            <span>Dealer Tools</span>
                        </Link>
                        <a
                            @click.prevent="toggleItemFeed"
                            href="#"
                            v-if="isDealer"
                            aria-label="Item Feed" 
                            role="link"
                        >
                            <ItemFeedIcon
                                alt="item feed icon"
                                class="utility-icon"
                            />
                            <span>Item Feed</span>
                        </a>
                        <Link :href="route('customer-service.index')" aria-label="Support" role="link">
                            <SupportIcon
                                alt="support icon"
                                class="utility-icon"
                            />
                            <span>Support</span>
                        </Link>
                    </nav>
                </div>

                    
                    <type-ahead v-if="!isApiServer" mobile-typeahead-dropdown class="header-search-container desktop-hidden-flex" :is-dealer="isDealer">

                        
                        <template #accountNav>
                            <a
                                @click.prevent="clickHandler(actionItem.actionName, actionItem.mobileCart)"
                                href="#"
                                v-for="actionItem of mobileActionItems"
                                :key="actionItem.label"
                                :class="actionItem.classes"
                                :aria-label="actionItem.label"
                                role="link"
                            >
                                <component
                                    :is="actionItem.icon"
                                    :alt="actionItem.alt"
                                    aria-hidden="true"
                                />
                                <div class="paragraph-caption">
                                    <span>{{ actionItem.label }}</span>
                                    <span v-if="actionItem.subLabel">{{
                                        actionItem.subLabel
                                    }}</span>
                                </div>
                            </a>
                            <mobile-menu
                                v-model="headerLinks"
                                :is-dealer="isDealer"
                                :is-logged-in="isLoggedIn"
                                :b2b-info="{
                                    totalQuantity: cartCount,
                                    totalStyles: totalStyles,
                                    totalSkus: totalSkus,
                                    totalPrice: subTotal,
                                }"
                            />
                        </template>
                    </type-ahead>
                    <type-ahead v-if="!isApiServer" class="header-search-container mobile-hidden-flex" :is-dealer="isDealer">

                                                
                        <template #accountNav>
                            <a
                                @click.prevent="clickHandler(actionItem.actionName, false)"
                                href="#"
                                v-for="actionItem of actionItems"
                                :key="actionItem.label"
                                :class="actionItem.classes"
                                :aria-label="actionItem.label"
                                role="link"
                            >
                                <component
                                    :is="actionItem.icon"
                                    :alt="actionItem.alt"
                                    aria-hidden="true"
                                />
                                <div class="paragraph-caption">
                                    <span>{{ actionItem.label }}</span>
                                    <span v-if="actionItem.subLabel">{{
                                        actionItem.subLabel
                                    }}</span>
                                </div>
                            </a>
                        </template>
                    </type-ahead>
                    <!-- <nav class="acccount-nav-container">
                        
                        
                    </nav> -->

            </div>
            <type-ahead v-if="!isApiServer" class="mobile-search-container" :is-dealer="isDealer" mobile/>
            <div v-if="isDealer && !isApiServer" class="mobile-b2b-menu">
                <a @click.prevent="toggleItemFeed"  href="#" class="b2b-menu-link" aria-label="Item Feed">
                        <ItemFeedIcon alt="" role="presentation" aria-hidden="true"/>
                        <span>Item Feed</span>
                </a>
                <a @click.prevent="clickHandler('quickOrder')" href="#" class="b2b-menu-link" aria-label="Quick Order">
                    <QuickOrderMobileIcon alt="" role="presentation" aria-hidden="true"/>
                    <span>Quick Order</span>
                </a>
                <a @click.prevent="clickHandler('checkout')" href="#" class="b2b-menu-link" aria-label="Checkout">
                    <CartMobileIcon alt="" role="presentation" aria-hidden="true"/>
                    <span>Checkout</span>
                </a>
            </div>
        </header>
        <div v-if="isApiServer" class="header-divider"></div>
        <div id="typeahead-dropdown"></div>
        <mega-menu v-if="!isApiServer" v-model="headerLinks" />
        <div class="authorization_popup-background" v-if="showFlyoutBackground"></div>

        <LoginFlyout v-if="!isApiServer" v-model:visible="isLoginFlyoutOpened" />
        <HeaderFlyout
            v-if="!isApiServer"
            v-model:visible="isHeaderFlyoutOpened"
            :userInfo="userInfo"
        />
        <BuyStackFlyout
            v-if="!isApiServer"
            v-model:visible="isBuystackFlyoutOpened"
            :product_seo_name="quickView.product_seo_name"
            :color="quickView.color"
        />
        <ItemFeed v-if="!isApiServer" v-model:showDrawer="showItemFeed" />
    </div>
</template>

<script setup lang="ts">
    import Cms from "@/components/Cms.vue";
    import MobileMenu from "@/components/MobileMenu.vue";
    import TypeAhead from "@/components/TypeAhead.vue";
    import ItemFeed from "@/components/ItemFeed.vue";
    import MegaMenu from "@/components/Menu/MegaMenu.vue";
    import BrowserSupport from "@/components/BrowserSupport.vue";
    import {
        useDisclosure,
        useTrapFocus,
        useDropdown,
    } from "@storefront-ui/vue";
    import { ref, watch, computed, toRefs, inject } from "vue";
    import { unrefElement } from "@vueuse/core";
    import { type MegaMenuHeader } from "@interfaces";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { registeredComponents } from "@root/mega-menu-init";
    import LoginFlyout from "@/components/auth/LoginFlyout.vue";
    import { type User } from "@interfaces/User";
    import HeaderFlyout from "@/components/account/HeaderFlyout.vue";
    import BuyStackFlyout from "@/components/BuyStackFlyout.vue";
    import CartPreview from "@/components/cart/CartPreview.vue";
    import { watchDeep } from "@vueuse/core";
    import { Link, router } from "@inertiajs/vue3";
    import { usePage } from "@inertiajs/vue3";
    import accountIcon from "@icons/account-icon.svg";
    import cartIcon from "@icons/cart-icon.svg";
    import { useDialog } from 'primevue/usedialog';
    import QuickOrderIcon from "@icons/quick-order-icon.svg";
    import RothcoIcon from "@icons/rothcoLogo.svg";
    import RothcoMobileIcon from "@icons/rothco-mobile.svg";
    import DealerIcon from "@icons/dealer icon.svg";
    import RetailIcon from "@icons/retail-icon.svg";
    import DealerToolsIcon from "@icons/dealer-tools.svg";
    import ItemFeedIcon from "@icons/item-feed-icon.svg";
    import SupportIcon from "@icons/support-icon.svg";
    import QuickOrderMobileIcon from "@icons/quick_order_mob.svg";
    import CartMobileIcon from "@icons/cart_red_mobile.svg";
    let route = inject('route');
    let props = defineProps({
        categoryHeaders: {
            type: Array as PropType<Link[]>,
            required: true
        },
        user: {
            type: Object as PropType<User>,
            required: false,
            default(){
                return {
                    user_id: null,
                    username: null,
                    email: null,
                    is_dealer: false,
                    dealer_no: null
                }
            }
        },
        list: {
            type: Object,
            required: false
        }
    });

    const dialog = useDialog();
    
    const showItemFeed = ref(false);
    const toggleItemFeed = () => {
        showItemFeed.value = !showItemFeed.value;
    };
    watch(showItemFeed, (newVal)=>{
        let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');
        if (newVal) {
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.add('hidden');
            }
        }else{
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.remove('hidden');
            }
        }
    })

    let { categoryHeaders, list } = toRefs(props);
    const getRegisteredComponents = () => registeredComponents;

    const settingsStore = useSettingsStore();
    const {
        appendLinks,
        setUser,
        toggleFlyout,
        setList,
        toggleCartPreview,
        toggleBuystackFlyout
    } = settingsStore;

    let {
        links,
        headerLinks,
        currentList,
        accountDisplay,
        is_dealer,
        userInfo,
        isLoggedIn,
        isLoginFlyoutOpened,
        isHeaderFlyoutOpened,
        isBuystackFlyoutOpened,
        quickView,
        isShowCartPreview,
        isApiServer,
    } = storeToRefs(settingsStore);

    const searchParams = computed(() => {
        if(isApiServer.value){
            return {
                'data.server.$eq': 'api'
            }
        }else{
            return {
                'data.server.$or': [
                    {
                        $exists: false
                    },
                    {
                        $eq: null
                    },
                    {
                        $eq: 'www'
                    }
                ]
            }
    }
    });

    setUser(props.user);
    if (!isApiServer.value) {
        appendLinks(categoryHeaders.value);
        setList(list.value);
    }

    const showFlyoutBackground = computed(()=>{
        return isLoginFlyoutOpened.value || isHeaderFlyoutOpened.value || showItemFeed.value;
    })

    let isDealer = computed(() => {
        return is_dealer.value;
    });

    let account = computed(() => {
        return accountDisplay.value;
    });

    let cartCount = computed(() => {
        return currentList.value.total_quantity ?? 0;
    });

    let totalSkus = computed(() => {
        return currentList.value.total_skus ?? 0;
    });

    let totalStyles = computed(() => {
        return currentList.value.total_styles ?? 0;
    });

    let subTotal = computed(() => {
        return parseFloat(currentList.value.total || 0);
    });

    let openCartPreview = () => {
            dialog.open(CartPreview, {
                props: {
                    showHeader: false,
                    modal: false
                }
            });
    };

    const findNode = (keys: string[], node: ComputedRef<Node>): Node => {
        if (keys.length > 1) {
            const [currentKey, ...restKeys] = keys;
            return findNode(
                restKeys,
                node.children?.find((child) => child.key === currentKey) || node
            );
        } else {
            return (
                node.children?.find((child) => child.key === keys[0]) || node
            );
        }
    };

    const { close, open, isOpen } = useDisclosure();
    const { referenceRef, floatingRef, style } = useDropdown({
        isOpen,
        onClose: close,
        placement: "bottom-start",
        middleware: []
    });

    const drawerRef = ref();
    const megaMenuRef = ref();
    const triggerRefs = ref();
    const activeNode = ref<string[]>([]);

    const activeMenuContext = ref<MegaMenuHeader>();

    let megaMenuFields = computed(() => {
        return Object.keys;
    });

    const activeMenu = ref<Node>({
        key: "",
        value: { label: "", counter: 0 },
        isLeaf: false,
        children: []
    });
    const activeSubMenu = ref<Node>({
        key: "",
        value: { label: "", counter: 0 },
        isLeaf: false,
        children: []
    });
    // const activeMenu = computed(() => findNode(activeNode.value, content) ?? { children: [] });
    const bannerNode = computed(() =>
        findNode(activeNode.value.slice(0, 1), content)
    );

    const trapFocusOptions = {
        activeState: isOpen,
        arrowKeysUpDown: true,
        initialFocus: "container"
    } as const;
    useTrapFocus(
        computed(() => megaMenuRef.value?.[0]),
        trapFocusOptions
    );
    useTrapFocus(drawerRef, trapFocusOptions);

    const openMenu = (menuType: string[]) => {
        activeNode.value = menuType;
        open();
    };

    const clickHandler = (actionName: string, mobileCart: boolean) => {
        if(mobileCart && isLoggedIn.value) {
            router.visit(route("cart.show"));
        } else if (actionName === "handleAccountLogin") {
            handleAccountLogin();
        } else if (
            actionName === "openCartPreview" &&
            parseInt(cartCount.value)
        ) {
            openCartPreview();

        }else if(actionName =='checkout') {
            router.visit(route("checkout.express"));
        }else {
            router.visit(route("index.quickOrdering"));
        }
    };

    const handleAccountLogin = () => {
        toggleFlyout();
    };

    const focusTrigger = (index: number) => {
        unrefElement(triggerRefs.value[index]).focus();
    };

    const inputValue = ref("");

    const search = () => {
        alert(`Successfully found 10 results for ${inputValue.value}`);
    };

    const actionItems = computed(()=> {
        let arr = [{
                icon: accountIcon,
                alt: "account icon",
                classes: ["account-link"],
                label: account.value.text,
                subLabel: account.value.subText,
                actionName: "handleAccountLogin"
            },
            {
                icon: cartIcon,
                alt: "cart icon",
                classes: ["account-link", "cart-link"],
                label: `Cart`,
                subLabel: `${cartCount.value} Items`,
                actionName: "openCartPreview"
            }
        ];

        if(isDealer.value){
            arr.unshift({
                icon: QuickOrderIcon,
                alt: "quick order icon",
                classes: ["account-link", "quick-order-link"],
                label: "Quick Order",
                actionName: "handleQuickOrder"
            })
        }

        return arr;
        
    });

    const mobileActionItems = computed(()=>{
        return [{
                icon: accountIcon,
                alt: "account icon",
                classes: ["account-link"],
                label: account.value.text,
                subLabel: account.value.subText,
                actionName: "handleAccountLogin",
                mobileCart: false
            },
            {
                icon: cartIcon,
                alt: "cart icon",
                classes: ["account-link", "cart-link"],
                label: `Cart`,
                subLabel: `${cartCount.value} Items`,
                actionName: "openCartPreview",
                mobileCart: true,
            }
        ];
    });


    type Node = {
        key: string;
        parent?: Node;
        value: {
            label: string;
            counter: number;
            link?: string;
            banner?: string;
            bannerTitle?: string;
            tag?: string;
            params?: string[];
        };
        useCmsMegaMenu?: boolean;
        children?: Node[];
        isLeaf: boolean;
    };

    let content = computed(() => {
        let rootNode: Node = {
            key: "root",
            value: { label: "All Products", counter: 0 },
            isLeaf: false,
            children: []
        };
        rootNode.children = headerLinks.value.map((link: any) => {
            let node = {
                key: link.text.toUpperCase(),
                parent: rootNode,
                value: {
                    counter: link.secondary?.length,
                    label: link.text,
                    link: link.url,
                    params: link.urlParams
                },
                useCmsMegaMenu: link.useCmsMegaMenu ?? false,
                isLeaf:
                    link.secondary && link.secondary?.length > 0 ? false : true,
                children: []
            };

            if (link.secondary && link.secondary?.length > 0) {
                node.children = link.secondary.map((sublink: any) => {
                    let secondaryNode = {
                        parent: node,
                        key: sublink.text.toUpperCase(),
                        value: {
                            counter: sublink.tertiary?.length,
                            label: sublink.text,
                            link: sublink.url,
                            tag: sublink.tag?.value?.data?.tagname,
                            params: sublink.urlParams
                        },
                        isLeaf: sublink.tertiary ? false : true,
                        children: []
                    };

                    if (sublink.tertiary && sublink.tertiary?.length > 0) {
                        secondaryNode.children = sublink.tertiary.map(
                            (tertiarylink: any) => {
                                return {
                                    parent: secondaryNode,
                                    key: tertiarylink.text.toUpperCase(),
                                    value: {
                                        counter: 0,
                                        label: tertiarylink.text,
                                        link: tertiarylink.url,
                                        params: tertiarylink.urlParams
                                    },
                                    isLeaf: true
                                };
                            }
                        );
                    }
                    return secondaryNode;
                });
            }
            return node;
        });
        return rootNode;
    });

    let activeBanner = computed(() => {
        let activeMenuKey = "";
        if (
            activeSubMenu.value.key != "" &&
            activeMenuContext.value.slug?.includes(activeSubMenu.value.key)
        ) {
            activeMenuKey = activeSubMenu.value.key;
        } else if (activeMenu.value.key != "") {
            activeMenuKey = activeMenu.value.key;
        } else {
            return null;
        }

        return `banner-${activeMenuKey}`.toLowerCase();
    });

    let bannerUrl = computed(() => {
        if (activeBanner.value == null) {
            return null;
        }
        return `/index/${activeBanner.value}`;
    });

    let activeMenuHasTertiaryCategories = computed(() => {
        return (
            activeMenu.value.children?.some(
                (node) => (node.children?.length ?? 0) > 0
            ) ?? false
        );
    });

    function openLink({ menuNode, subMenu = false, mouseLeft = false }) {
        if (
            (menuNode.children && menuNode.children.length > 0) ||
            menuNode.useCmsMegaMenu
        ) {
            if (subMenu == false) {
                openMenu([menuNode.key]);
                activeMenu.value = menuNode;
                activeSubMenu.value = {
                    key: "",
                    value: { label: "", counter: 0 },
                    children: [],
                    isLeaf: false
                };
            } else {
                activeSubMenu.value = menuNode;
            }
        } else {
            if (subMenu) {
                activeSubMenu.value = {
                    key: "",
                    value: { label: "", counter: 0 },
                    children: [],
                    isLeaf: false
                };
            } else {
                activeMenu.value = {
                    key: "",
                    value: { label: "", counter: 0 },
                    children: [],
                    isLeaf: false
                };
            }
        }

        if (mouseLeft) {
            close();
        }
    }
    watchDeep(() => props.user, (newVal) => {
        if(newVal.user_id){
            window?.clarity?.('set', 'customUserId', newVal.username);
        }else{
            window?.clarity?.('set', 'customUserId', null);
        }
        setUser(newVal);
    });

    watchDeep(() => list, (newVal) => {
        setList(newVal.value);
    });

</script>